<template>
  <div class="foot-container">
    <div class="cloud-content">
      <ul class="cloudUl main">
        <li class="cloudLi">
          <div class="cloudDiv">
            <div class="yuan" @click="toPage('/index', 1)">
              <img src="https://oss.cloudcpc.com/foot_01.png" alt="" />
            </div>
            <div class="written">
              <span @click="toPage('/exhibition', 1)">数字展厅</span>
              <!-- <span @click="toPage('/vr',1)">VR</span>
              <span @click="toPage('/ar',1)">AR</span> -->
              <span @click="toPage('/threeD', 1)">3D动画</span>
              <span @click="toPage('/video', 1)">短视频运营</span>
              <span @click="toPage('/applet', 1)">小程序开发</span>
              <span @click="toPage('/app', 1)">APP开发</span>
            </div>
            <div class="written">
              <!-- <span @click="toPage('/vrselect',1)">线上选型</span> -->
              <span @click="toPage('/mg', 1)">MG动画</span>
              <span @click="toPage('/overseas', 1)">海外推广</span>
            </div>
          </div>
        </li>
        <li class="cloudLi">
          <div class="cloudDiv">
            <div class="yuan" @click="toPage('/digitIndex', 2)">
              <img src="https://oss.cloudcpc.com/foot_02.png" alt="" />
            </div>
            <div class="written">
              <span @click="toPage('/mes', 2)">MES</span>
              <span @click="toPage('/erp', 2)">ERP</span>
              <span @click="toPage('/aps', 2)">APS</span>
              <span @click="toPage('/wms', 2)">WMS</span>
              <span @click="toPage('/qms', 2)">QMS</span>
            </div>
            <div class="written">
              <span @click="toPage('/bidata', 2)">BI数据可视化</span>
              <span @click="toPage('/acquisition', 2)">数据采集</span>
              <span @click="toPage('/device', 2)">设备管理</span>
              <span @click="toPage('/remote', 2)">远程运维</span>
              <span @click="toPage('/visua', 2)">3D可视化</span>
            </div>
          </div>
        </li>
        <li class="cloudLi">
          <div class="cloudDiv">
            <a href="http://texdigi.com/#/" target="_blank">
              <div class="yuan">
                <img src="https://oss.cloudcpc.com/foot_03.png" alt="" />
              </div>
            </a>
            <div class="written">
              <span>
                <a href="http://texdigi.com/#/equip" target="_blank"
                  >设备管理</a
                >
              </span>
              <span>
                <a href="http://texdigi.com/#/collection" target="_blank"
                  >数据采集</a
                >
              </span>
              <span>
                <a
                  href="http://texdigi.com/#/solution/visualization"
                  target="_blank"
                  >数据可视化</a
                >
              </span>
              <span>
                <a href="http://texdigi.com/#/solution/blending" target="_blank"
                  >智慧配棉</a
                >
              </span>
              <span>
                <a href="http://texdigi.com/#/solution/quality" target="_blank"
                  >质量管理</a
                >
              </span>
            </div>
            <div class="written">
              <span>
                <a
                  href="http://texdigi.com/#/solution/productionManagement"
                  target="_blank"
                  >生产管理</a
                >
              </span>
              <span>
                <a href="http://texdigi.com/#/solution/material" target="_blank"
                  >物料管理</a
                >
              </span>
              <span>
                <a
                  href="http://texdigi.com/#/solution/datamanage"
                  target="_blank"
                  >产品数据</a
                >
              </span>
              <span>
                <a href="http://texdigi.com/#/mes" target="_blank">MES/MOM</a>
              </span>
              <span>
                <a href="http://texdigi.com/#/erp" target="_blank">ERP</a>
              </span>
            </div>
            <div class="written">
              <span>
                <a href="http://texdigi.com/#/wms" target="_blank">WMS</a>
              </span>
              <span>
                <a href="http://texdigi.com/#/fzy" target="_blank">纺智云</a>
              </span>
              <span>
                <a href="http://texdigi.com/#/textile/index" target="_blank"
                  >纺织供应链</a
                >
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="main foot-content">
      <div class="netLogo">
        <img src="https://oss.cloudcpc.com/logo(2).png" alt="" />
      </div>
      <div class="contact">
        <div class="address">
          <p class="addres-tips">联系我们</p>
          <p class="contact-date">
            <!-- <img src="~assets/image/contact-phone.png" alt=""> -->
            电话：{{ contantData.mobile }}&nbsp;/&nbsp;{{ contantData.phone }}
          </p>
          <p class="contact-date">地址:{{ contantData.addr }}</p>
          <p class="contact-date">邮箱:ka@2025.net</p>
        </div>
        <!-- <div class="address">
          <p class="addres-tips">友情链接</p>
          <p class="contact-date"><a href="http://www.sinomach.com.cn/" target="_blank">中国机械工业集团有限公司</a></p>
          <p class="contact-date"><a href="http://www.chtgc.com/pcindex.html" target="_blank">中国恒天集团有限公司</a></p>
          <p class="contact-date"><a href="http://www.jwgf.com/" target="_blank">经纬纺织机械股份有限公司</a></p>
          <p class="contact-date"><a href="http://www.zzfj.com/" target="_blank">恒天重工股份有限公司</a></p>
          <p class="contact-date"><a href="https://www.fongs.com/" target="_blank">中国恒天立信国际有限公司</a></p>
        </div> -->
        <div class="gzh-container">
          <!-- <p class="addres-tips ">关注我们</p> -->
          <div class="gzhOne gzhTwo">
            <div class="gzh">
              <img
                class="gzh-img01"
                src="https://oss.cloudcpc.com/all_foot01.png"
                alt=""
              />
              <p class="gzh-name">高新技术企业证书</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img01"
                src="https://oss.cloudcpc.com/all_foot02.png"
                alt=""
              />
              <p class="gzh-name">ICP证书</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img01"
                src="https://oss.cloudcpc.com/all_foot03.png"
                alt=""
              />
              <p class="gzh-name">软件产品证书</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img01"
                src="https://oss.cloudcpc.com/all_foot04.png"
                alt=""
              />
              <p class="gzh-name">软件企业证书</p>
            </div>
          </div>
          <div class="gzhOne">
            <div class="gzh">
              <img
                class="gzh-img"
                src="https://oss.cloudcpc.com/foot_erwei01.png"
                alt=""
              />
              <p class="gzh-name">抖音号</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img"
                src="https://oss.cloudcpc.com/foot_erwei02.png"
                alt=""
              />
              <p class="gzh-name">视频号</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img"
                src="https://oss.cloudcpc.com/foot_erwei03.png"
                alt=""
              />
              <p class="gzh-name">公众号</p>
            </div>
            <div class="gzh">
              <img
                class="gzh-img"
                src="https://oss.cloudcpc.com/new_shuz.png"
                alt=""
              />
              <p class="gzh-name">数智纺小程序</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-content02">
      <ul class="fast">
        <li class="fast-item">
          <a href="http://www.sinomach.com.cn/" target="_blank"
            >中国机械工业集团有限公司</a
          >
        </li>
        <li class="fast-item">
          <a href="http://www.chtgc.com/pcindex.html" target="_blank"
            >中国恒天集团有限公司</a
          >
        </li>
        <li class="fast-item">
          <a href="http://www.jwgf.com/" target="_blank"
            >经纬纺织机械股份有限公司</a
          >
        </li>
        <li class="fast-item">
          <a href="http://www.zzfj.com/" target="_blank"
            >恒天重工股份有限公司</a
          >
        </li>
        <li class="fast-item last">
          <a href="https://www.fongs.com/" target="_blank"
            >中国恒天立信国际有限公司</a
          >
        </li>
      </ul>
      <div class="copyright">
        {{ copyRightData.web_copyright }} ICP证：<a
          href="https://beian.miit.gov.cn/"
          target="_blank"
        >
          {{ copyRightData.web_miitbeian }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getLists } from "../../api/index";
export default {
  data() {
    return {
      contantData: "",
      copyRightData: "",
    };
  },
  mounted() {
    this.getListsData();
  },
  methods: {
    getListsData() {
      getLists().then((res) => {
        // console.log(res[9]);
        console.log(res);
        this.copyRightData = res[2];
        this.contantData = res[9];
      });
    },

    //底部跳转对应页面
    toPage(path, num) {
      //this.$store.commit("SET_NAVALLINDEX", num);
      sessionStorage.setItem("navIndex", JSON.stringify(num));
      var routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang='scss'>
@import "./index";
</style>
